import { render, staticRenderFns } from "./GiftDetail.vue?vue&type=template&id=01b96b2a&scoped=true"
import script from "./GiftDetail.vue?vue&type=script&lang=js"
export * from "./GiftDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b96b2a",
  null
  
)

export default component.exports